import { get } from 'vuex-pathify';

export default {
  data: () => ({
    rules: {
      lowerCase: v => !v || /[a-z]+/.test(v) || 'rules.lowerCase',
      digit: v => !v || /[1-9]+/.test(v) || 'rules.digit',
      specialChar: v => !v || /[!@#\\$%\\^&\\*(){}\\[\]\\|:”;\\'<>,.]+/.test(v) || 'rules.specialChar',
      upperCase: v => !v || /[A-Z]+/.test(v) || 'rules.upperCase',
    },
  }),
  computed: {
    upperCase: get('admin/settingsValues@password_at_least_one_upper_case'),
    lowerCase: get('admin/settingsValues@password_at_least_one_lower_case'),
    digit: get('admin/settingsValues@password_at_least_one_digit'),
    specialChar: get('admin/settingsValues@password_at_least_one_special_char'),
    minLength: get('admin/settingsValues@password_minimum_length'),
    rulesValues() {
      return {
        upperCase: this.upperCase,
        lowerCase: this.lowerCase,
        digit: this.digit,
        specialChar: this.specialChar,
      };
    },
    turnedOnRulesKeys() {
      return Object.keys(this.rules).filter(key => this.rulesValues[key]);
    },
    computedRules() {
      return [
        ...this.turnedOnRulesKeys.map(key => this.rules[key]),
        v => !v || v.length >= this.minLength || this.$i18n.t('rules.minPasswordLength', { length: this.minLength }),
      ];
    },
  },
};
